import React, { useCallback, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import { WitLabel } from "./common";
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";
import "./jsonEditor.css";
import Selector from "../../../components/selector";

export enum Mode {
  form = "form",
  tree = "tree",
  view = "view",
  code = "code",
  text = "text",
}
type Option = { value: Mode; label: Mode };
export function JsonEditor({ formData, onChange, schema, defaultValue }: FieldProps) {
  const modeOptions: Option[] = Object.entries(Mode).map(([, val]) => ({
    value: val,
    label: val,
  }));
  const [editorKey, setEditorKey] = useState<number>(Math.random());
  const [mode, setMode] = useState<Option>(modeOptions[0]);

  const handleSelectMode = useCallback((selectedOption: Option) => {
    setMode(selectedOption);
    setEditorKey(Math.random);
  }, []);

  const handleChange = useCallback((json: string) => onChange(json), [onChange]);
  
  return (
    <>
      <WitLabel>{schema?.title}</WitLabel>
      <Selector options={modeOptions} value={mode} onChange={handleSelectMode} />
      <Editor
        htmlElementProps={{ style: { height: "800px" } }}
        key={editorKey}
        mode={mode.value}
        history
        value={formData}
        onChange={handleChange}
      />
    </>
  );
}
